// import React, { useState, useRef, useEffect } from 'react';
// import { BootstrapToolTip } from '../ToolTip';

// export default function TextViewWithEllipsis({
//     text,
//     maxWidth = '200px',
//     className = '',
//     showTooltip = true,
//     lines = 1,
// }) {
//     const [isTruncated, setIsTruncated] = useState(false);
//     const textRef = useRef(null);

//     useEffect(() => {
//         if (textRef.current) {
//             // Check if text is truncated (scrollWidth > clientWidth for single line)
//             // or scrollHeight > clientHeight for multi-line
//             const element = textRef.current;
//             if (lines === 1) {
//                 setIsTruncated(element.scrollWidth > element.clientWidth);
//             } else {
//                 setIsTruncated(element.scrollHeight > element.clientHeight);
//             }
//         }
//     }, [text, lines]);

//     const textStyle = {
//         maxWidth,
//         overflow: 'hidden',
//         textOverflow: 'ellipsis',
//         whiteSpace: lines === 1 ? 'nowrap' : 'normal',
//         display: '-webkit-box',
//         WebkitLineClamp: lines > 1 ? lines : 'none',
//         WebkitBoxOrient: 'vertical',
//         wordBreak: 'break-word',
//     };

//     const content = (
//         <span ref={textRef} style={textStyle} className={className}>
//             {text || '-'}
//         </span>
//     );

//     if (showTooltip && isTruncated && text) {
//         return <BootstrapToolTip text={text}>{content}</BootstrapToolTip>;
//     }

//     return content;
// }

import React from 'react';
import styled from '@emotion/styled';
import { BootstrapToolTip } from '../ToolTip';

const EllipsisText = styled.span`
    display: inline-block;
    max-width: ${(props) => props.maxWidth || '300px'};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;

    ${(props) =>
        props.lines &&
        props.lines > 1 &&
        `
        display: -webkit-box;
        -webkit-line-clamp: ${props.lines};
        -webkit-box-orient: vertical;
        white-space: normal;
        word-break: break-word;
    `}

    ${(props) => props.className}
`;

const TextWrapper = styled.div`
    display: inline-flex;
    align-items: center;
    width: 100%;
`;

export default function TextViewWithEllipsis({
    text,
    maxWidth = '200px',
    lines = 1,
    showTooltip = true,
    className = '',
    flex = true,
}) {
    const displayText = text || '-';

    const textElement = (
        <EllipsisText maxWidth={maxWidth} lines={lines} className={className}>
            {displayText}
        </EllipsisText>
    );

    if (!showTooltip || !text) {
        return textElement;
    }

    return (
        <BootstrapToolTip text={text}>{flex ? <TextWrapper>{textElement}</TextWrapper> : textElement}</BootstrapToolTip>
    );
}
